/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuprequired1Inputs */

const en_signuprequired1 = /** @type {(inputs: Signuprequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const de_signuprequired1 = /** @type {(inputs: Signuprequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflichtfrage`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Signuprequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuprequired1 = /** @type {((inputs?: Signuprequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuprequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuprequired1(inputs)
	return de_signuprequired1(inputs)
});
export { signuprequired1 as "signupRequired" }